/**
 * @generated SignedSource<<0f459c5c6fb994d8bde3d35a1982b0e9>>
 * @relayHash 628a56ca33e9462b0d28ee38c9055b21
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 83b376ae5628ba7b036093c628acc4c9bcbbfa4d904bbfabdb1d1199730710a7

import type { ConcreteRequest } from 'relay-runtime';
export type useNewUserTemplatesGetMultipleTemplateInfoQuery$variables = {
  templateId0: string;
  templateId1: string;
  templateId2: string;
};
export type useNewUserTemplatesGetMultipleTemplateInfoQuery$data = {
  readonly template0: {
    readonly author: string | null;
    readonly blueprintModuleCompleteKey: string | null;
    readonly categoryIds: ReadonlyArray<string | null>;
    readonly contentBlueprintId: string | null;
    readonly darkModeIconURL: string | null;
    readonly description: string | null;
    readonly hasGlobalBlueprintContent: boolean;
    readonly hasWizard: boolean | null;
    readonly iconURL: string | null;
    readonly isFavourite: boolean | null;
    readonly isNew: boolean | null;
    readonly isPromoted: boolean | null;
    readonly itemModuleCompleteKey: string | null;
    readonly keywords: ReadonlyArray<string | null> | null;
    readonly name: string | null;
    readonly recommendationRank: number | null;
    readonly styleClass: string | null;
    readonly templateId: string | null;
    readonly templateType: string | null;
  } | null;
  readonly template1: {
    readonly author: string | null;
    readonly blueprintModuleCompleteKey: string | null;
    readonly categoryIds: ReadonlyArray<string | null>;
    readonly contentBlueprintId: string | null;
    readonly darkModeIconURL: string | null;
    readonly description: string | null;
    readonly hasGlobalBlueprintContent: boolean;
    readonly hasWizard: boolean | null;
    readonly iconURL: string | null;
    readonly isFavourite: boolean | null;
    readonly isNew: boolean | null;
    readonly isPromoted: boolean | null;
    readonly itemModuleCompleteKey: string | null;
    readonly keywords: ReadonlyArray<string | null> | null;
    readonly name: string | null;
    readonly recommendationRank: number | null;
    readonly styleClass: string | null;
    readonly templateId: string | null;
    readonly templateType: string | null;
  } | null;
  readonly template2: {
    readonly author: string | null;
    readonly blueprintModuleCompleteKey: string | null;
    readonly categoryIds: ReadonlyArray<string | null>;
    readonly contentBlueprintId: string | null;
    readonly darkModeIconURL: string | null;
    readonly description: string | null;
    readonly hasGlobalBlueprintContent: boolean;
    readonly hasWizard: boolean | null;
    readonly iconURL: string | null;
    readonly isFavourite: boolean | null;
    readonly isNew: boolean | null;
    readonly isPromoted: boolean | null;
    readonly itemModuleCompleteKey: string | null;
    readonly keywords: ReadonlyArray<string | null> | null;
    readonly name: string | null;
    readonly recommendationRank: number | null;
    readonly styleClass: string | null;
    readonly templateId: string | null;
    readonly templateType: string | null;
  } | null;
};
export type useNewUserTemplatesGetMultipleTemplateInfoQuery = {
  response: useNewUserTemplatesGetMultipleTemplateInfoQuery$data;
  variables: useNewUserTemplatesGetMultipleTemplateInfoQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "templateId0"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "templateId1"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "templateId2"
  }
],
v1 = [
  {
    "kind": "ScalarField",
    "name": "templateId"
  },
  {
    "kind": "ScalarField",
    "name": "contentBlueprintId"
  },
  {
    "kind": "ScalarField",
    "name": "blueprintModuleCompleteKey"
  },
  {
    "kind": "ScalarField",
    "name": "itemModuleCompleteKey"
  },
  {
    "kind": "ScalarField",
    "name": "templateType"
  },
  {
    "kind": "ScalarField",
    "name": "name"
  },
  {
    "kind": "ScalarField",
    "name": "description"
  },
  {
    "kind": "ScalarField",
    "name": "iconURL"
  },
  {
    "kind": "ScalarField",
    "name": "darkModeIconURL"
  },
  {
    "kind": "ScalarField",
    "name": "styleClass"
  },
  {
    "kind": "ScalarField",
    "name": "hasWizard"
  },
  {
    "kind": "ScalarField",
    "name": "isNew"
  },
  {
    "kind": "ScalarField",
    "name": "isPromoted"
  },
  {
    "kind": "ScalarField",
    "name": "isFavourite"
  },
  {
    "kind": "ScalarField",
    "name": "hasGlobalBlueprintContent"
  },
  {
    "kind": "ScalarField",
    "name": "categoryIds"
  },
  {
    "kind": "ScalarField",
    "name": "keywords"
  },
  {
    "kind": "ScalarField",
    "name": "recommendationRank"
  },
  {
    "kind": "ScalarField",
    "name": "author"
  }
],
v2 = [
  {
    "alias": "template0",
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "templateId0"
      }
    ],
    "concreteType": "TemplateInfo",
    "kind": "LinkedField",
    "name": "templateInfo",
    "plural": false,
    "selections": (v1/*: any*/)
  },
  {
    "alias": "template1",
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "templateId1"
      }
    ],
    "concreteType": "TemplateInfo",
    "kind": "LinkedField",
    "name": "templateInfo",
    "plural": false,
    "selections": (v1/*: any*/)
  },
  {
    "alias": "template2",
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "templateId2"
      }
    ],
    "concreteType": "TemplateInfo",
    "kind": "LinkedField",
    "name": "templateInfo",
    "plural": false,
    "selections": (v1/*: any*/)
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useNewUserTemplatesGetMultipleTemplateInfoQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useNewUserTemplatesGetMultipleTemplateInfoQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "628a56ca33e9462b0d28ee38c9055b21",
    "id": "83b376ae5628ba7b036093c628acc4c9bcbbfa4d904bbfabdb1d1199730710a7",
    "metadata": {},
    "name": "useNewUserTemplatesGetMultipleTemplateInfoQuery",
    "operationKind": "query",
    "text": "query useNewUserTemplatesGetMultipleTemplateInfoQuery($templateId0:ID!,$templateId1:ID!,$templateId2:ID!){template0:templateInfo(id:$templateId0){templateId,contentBlueprintId,blueprintModuleCompleteKey,itemModuleCompleteKey,templateType,name,description,iconURL,darkModeIconURL,styleClass,hasWizard,isNew,isPromoted,isFavourite,hasGlobalBlueprintContent,categoryIds,keywords,recommendationRank,author},template1:templateInfo(id:$templateId1){templateId,contentBlueprintId,blueprintModuleCompleteKey,itemModuleCompleteKey,templateType,name,description,iconURL,darkModeIconURL,styleClass,hasWizard,isNew,isPromoted,isFavourite,hasGlobalBlueprintContent,categoryIds,keywords,recommendationRank,author},template2:templateInfo(id:$templateId2){templateId,contentBlueprintId,blueprintModuleCompleteKey,itemModuleCompleteKey,templateType,name,description,iconURL,darkModeIconURL,styleClass,hasWizard,isNew,isPromoted,isFavourite,hasGlobalBlueprintContent,categoryIds,keywords,recommendationRank,author}}"
  }
};
})();

(node as any).hash = "f2f7112db65307812c35e5adf447d1ca";

export default node;
